import { Component, ViewEncapsulation, OnInit } from '@angular/core';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { BookService } from 'src/shared/services/book.service';

@Component({
  templateUrl: 'select-residential-booking-test.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SelectResidentialBookingTestPage implements OnInit {

  isRightSideContent = true;
  dialogParams: any;

  testOptions = [
    { label: 'Control (Old View — Collapsed)', variant: 'control' },
    { label: 'Variant 1 (Old View — Uncollapsed)', variant: 'old-view-uncollapsed' },
    { label: 'Variant 2 (New View — Collapsed)', variant: 'new-view-collapsed' },
    { label: 'Variant 3 (New View — Uncollapsed)', variant: 'new-view-uncollapsed' },
  ];

  constructor(
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    private bookService: BookService
  ) {}

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.dialogParams = await this.storage.retrieve('dialog-params') || {};
    this.rightSidePanelService.setDialogPageTitle('Select Booking Test');
  }

  async selectVariant(option: { label: string; variant: string }) {
    const flagKey = BookService.getBookingViewV2FlagKey();
    localStorage.setItem(`posthog_variant_${flagKey}`, option.variant);
    const params = {
      ...this.dialogParams,
      bookingViewV2Variant: option.variant,
    };
    await this.bookService.goToBookJob(params);
  }
}
